import ICarriersResponse from '../interfaces/ICarriersResponse';

export const getCheckedCarriers = (
    carriersResponse: ICarriersResponse[],
    carriersCheckedToDelete: ICarriersResponse[],
) => {
    carriersResponse.forEach(c => {
        if (carriersCheckedToDelete.map(d => d.id).includes(c.id)) {
            c.checked = true;
        } else {
            c.checked = false;
        }
    });

    return carriersResponse;
};
